import { GoalTypes, TPGoalDataCollectionMethod } from '../../../constants/general';

export const getDataCollectionMethod = (goalType: GoalTypes) => {
  switch (goalType) {
    case GoalTypes.BehaviorReduction:
      return [
        TPGoalDataCollectionMethod.DURATION,
        TPGoalDataCollectionMethod.INSTANCES,
        TPGoalDataCollectionMethod.RATE,
      ];
    case GoalTypes.Caregiver:
    case GoalTypes.SkillAcquisition:
      return [
        TPGoalDataCollectionMethod.DURATION,
        TPGoalDataCollectionMethod.INSTANCES,
        TPGoalDataCollectionMethod.PERCENTAGE,
        TPGoalDataCollectionMethod.RATE,
      ];
  }
};
